import React from "react";

interface IconProps {
  color: string;
}

const RoundedChecked: React.FC<IconProps> = ({
  color
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_17539_56208" fill="white">
      <path d="M0 8C0 3.58172 3.58172 0 8 0H12C16.4183 0 20 3.58172 20 8V12C20 16.4183 16.4183 20 12 20H8C3.58172 20 0 16.4183 0 12V8Z" />
    </mask>
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H12C16.4183 0 20 3.58172 20 8V12C20 16.4183 16.4183 20 12 20H8C3.58172 20 0 16.4183 0 12V8Z"
      fill={color}
    />
    <path
      d="M8 0V1.6H12V0V-1.6H8V0ZM20 8H18.4V12H20H21.6V8H20ZM12 20V18.4H8V20V21.6H12V20ZM0 12H1.6V8H0H-1.6V12H0ZM8 20V18.4C4.46538 18.4 1.6 15.5346 1.6 12H0H-1.6C-1.6 17.3019 2.69807 21.6 8 21.6V20ZM20 12H18.4C18.4 15.5346 15.5346 18.4 12 18.4V20V21.6C17.3019 21.6 21.6 17.3019 21.6 12H20ZM12 0V1.6C15.5346 1.6 18.4 4.46538 18.4 8H20H21.6C21.6 2.69807 17.3019 -1.6 12 -1.6V0ZM8 0V-1.6C2.69807 -1.6 -1.6 2.69807 -1.6 8H0H1.6C1.6 4.46538 4.46538 1.6 8 1.6V0Z"
      fill={color}
      mask="url(#path-1-inside-1_17539_56208)"
    />
    <path
      d="M6 10L9 13L14 8"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { RoundedChecked };
